import { createContext } from 'react';
export const RichTextEditorContext = createContext({
    defaultRichTextEditorContextValue: true,
});
//# sourceMappingURL=RichTextEditorContext.js.map